import React, { Component } from "react";
import { connect } from "react-redux";
import { Layout, LocaleProvider } from "antd";
import { Debounce } from "react-throttle";
import WindowResizeListener from "react-window-size-listener";
import { ThemeProvider } from "styled-components";
import authAction from "../../redux/auth/actions";
import appActions from "../../redux/app/actions";
import Sidebar from "../Sidebar/Sidebar";
import Topbar from "../Topbar/Topbar";
import AppRouter from "./AppRouter";

import { IntlProvider } from "react-intl";

import { AppLocale } from "../../dashApp";

import themes from "../../settings/themes";
import { themeConfig } from "../../settings";
import AppHolder from "./commonStyle";
import "./global.css";
import CustomStaticLogout from "../CustomStaticLogout";
import IdleTimer from "../IdleTimer/IdleTimer";

const { Content } = Layout;
const { logout } = authAction;
const { toggleAll } = appActions;
export class App extends Component {
  render() {
    const { url } = this.props.match;
    const { height } = this.props;
    const appHeight = window.innerHeight;
    const appWidth = window.innerWidth < 576 ? true : false;
    const { 
      locale, 
      // selectedTheme
     } = this.props;
    const currentAppLocale = AppLocale[locale];

   
    
    return (
      <LocaleProvider locale={currentAppLocale.antd}>
        <IntlProvider
          locale={currentAppLocale.locale}
          messages={currentAppLocale.messages}
        >
          <ThemeProvider theme={themes[themeConfig.theme]}>
            <AppHolder>
              <IdleTimer />
              <Layout style={{ height: appHeight, display: "flex", flexDirection: "column" }}>
                <Debounce time="200" handler="onResize">
                  <WindowResizeListener
                    onResize={(windowSize) =>
                      this.props.toggleAll(
                        windowSize.windowWidth,
                        windowSize.windowHeight
                      )
                    }
                  />
                </Debounce>
                <Layout style={{ flexDirection: "row", overflow: "hidden", flex: 1, minHeight: 0 }}>
                  <Sidebar url={url} />
                  <Layout
                    className="isoContentMainLayout dyn-list"
                  >
                    <Topbar url={url} />
                    <Content
                      className="isomorphicContent"
                    >
                      {this.props.auth && this.props.auth.logoutFlag ? <CustomStaticLogout/> : ''}
                      <AppRouter url={url} />
                    </Content>
                  </Layout>
                </Layout>
              </Layout>
            </AppHolder>
          </ThemeProvider>
        </IntlProvider>
      </LocaleProvider>
    );
  }
}

export default connect(
  (state) => ({
    auth: state.Auth,
    height: state.App.height,
    locale: state.LanguageSwitcher.language.locale,
  }),
  { logout, toggleAll }
)(App);
